import { PublicApiClient } from '@/services/PublicApiClient'

export default {
  checkNin(applicationId, tckn) {
    return PublicApiClient.post(
      'applications/' + applicationId + '/check-nin',
      {
        application_id: applicationId,
        tckn: tckn
      }
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  getRequiredDocuments(applicationId) {
    return PublicApiClient.get(
      'applications/' + applicationId + '/required-documents'
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  uploadPublicDocument(applicationId, formData) {
    return PublicApiClient.postForm(
      `applications/${applicationId}/upload-document`,
      formData
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  sendDocumentWaiting(applicationId, formData) {
    return PublicApiClient.get(
      `applications/${applicationId}/send-document-waiting`,
      formData
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  uploadKycDocument(applicationId, document) {
    return PublicApiClient.postForm(
      `applications/${applicationId}/upload-kyc-document`,
      document
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  sendKycApproval(applicationId) {
    return PublicApiClient.get(
      `applications/${applicationId}/send-kyc-approval`
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  getRequiredDKycocuments(applicationId) {
    return PublicApiClient.get(
      `applications/${applicationId}/view-kyc-document`
    )
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  getDigitalSignableDocument(documentHash) {
    return PublicApiClient.get(`order-documents/${documentHash}/get-digital-signable-document`)
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  viewDigitalSignableDocument(documentHash) {
    return PublicApiClient.get(`order-documents/${documentHash}/view-digital-signable-document`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  sendDigitalSignatureSmsToFarmer(applicationHash, documentId) {
    return PublicApiClient.post(`applications/${applicationHash}/documents/${documentId}/send-digital-signature-sms-to-farmer`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  confirmDigitaleSignableDocument(documentHash) {
    return PublicApiClient.post(`order-documents/${documentHash}/confirm-digital-signature`)
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  },
  verifyDigitalSignature(applicationHash, documentId, code) {
    return PublicApiClient.post(`applications/${applicationHash}/documents/${documentId}/verify-digital-signature`, {
      code: code
    })
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  }
}
